<template>
  <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('categoryGroup.list') }}</h3>
          </div>
          <div class="card-toolbar">
            <Button v-if="$can(abilities.CREATE_CATEGORIES)" btn-class="btn-sm" type="new" btn-text="categoryGroup.create" @click="openCategoryGroupModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_categoryGroup" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th class="min-w-50px">{{ $t('categoryGroup.name')}}</th>
              <th class="min-w-300px">{{ $t('categoryGroup.categories')}}</th>
              <th class="w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>
          </table>
        </div> 
      </div>
    </div>

    <CategoryGroupModal id="create-categoryGroup-modal" @load="fetchDatas"/> 
    <CategoryGroupModal id="edit-categoryGroup-modal" :form="formUpdateData" @load="fetchDatas" :edit="true"/>
</template>

<script setup>

import {computed, nextTick, onMounted, ref, watch} from "vue";
import i18n from '@/plugins/i18n';
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import CategoryGroupModal from "@/Modules/Projects/components/Modals/CategoryGroupModal.vue";
import abilities from "@/composables/abilities";

const {showSwal} = useSwal()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const { can } = useHasAbility()

const table = ref()

const formUpdateData = ref({
  id:'',
  name: '',
  project_category_id: []
})

onMounted(() => {
  fetchDatas()
})

watch(() => locale.value, () => {
  nextTick(() => fetchDatas() )
})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#kt_datatable_categoryGroup").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'asc']],
    ajax: {
      url: BASE_URL + "/get/projects/category/groups/datatable",
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      { data: "name" },
      { data: "project_categories" },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -3,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span >' + t + "</span>";
          
        },
      },
      {
        targets: -2,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          let result = ''
          for (let element in t) {
            result += '<span class="badge text-white" style="font-size:13px; margin:3px; padding:3px; background-color:' + t[element].color + ';">' + t[element].name + '</span>';
          }
          return result       
         },
      },
      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: function(t, a, e, l) {
          let render=""
          if(can(abilities.UPDATE_CATEGORIES)){
            let categories = e.project_categories?.map(el => el?.id)
            render += '<a data-id="' + e.id + '" data-name="' + e.name + '" data-categories=\'' + JSON.stringify(categories) + '\' data-default="' + e.default + '" href="javascript:;" class="btn btn-sm btn-clean btn-icon edit_btn" title="' + i18n.global.t('button.edit') + '"><i data-id="' + e.id + '" data-name="' + e.name + '" data-categories=\'' + JSON.stringify(categories) + '\' data-default="' + e.default + '" class="fas fa-edit fs-2" style="color: ' + Theme.gray + '"></i></a>';
          }
          if(can(abilities.DELETE_CATEGORIES)){
            render += '<a data-id="'+ e.id +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'" ></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#kt_datatable_categoryGroup .edit_btn", (e) => {
    const categoriesData = e.target.getAttribute('data-categories');
    formUpdateData.value.id = e.target.getAttribute('data-id')
    formUpdateData.value.name = e.target.getAttribute('data-name')
    formUpdateData.value.project_category_id = categoriesData ? JSON.parse(categoriesData) : [];
    $('#edit-categoryGroup-modal').modal('toggle')
  });

  $(document).on("click", "#kt_datatable_categoryGroup .delete_btn", (e) => {
    let id = e.target.getAttribute('data-id')
    delatecategoryGroup(id)
  });
}

function openCategoryGroupModal() {
  $('#create-categoryGroup-modal').modal('toggle')
}

async function delatecategoryGroup(id) {
    showSwal(
        '',
        i18n.global.t('categoryGroup.categoryGroup_deleted')
    ).then( async (result) => {
        if (result.value) {
            try {
                await store.dispatch('projectCategories/deleteCategoryGroup', id)
                table.value.ajax.reload()
                window.toastr['success'](i18n.global.t("notification.deleted_successfully"))
            }catch (e) {
            }
        }
  })
}
</script>
